/**
 * Error normalization. Every failed request becomes an ApiError with a
 * stable, lowercased `code` that UI copy is keyed on.
 *
 * The server `message` is developer-facing and is carried only for logging —
 * IT IS NEVER RENDERED to users.
 *
 * Known wire shapes (the manage plane is inconsistent by sub-plane):
 *   { error: "some_code", message: "…" }                 — flat HumanError
 *   { ok: false, error: { code: "SOME_CODE", message } } — okData envelope
 */
export class ApiError extends Error {
    code;
    httpStatus;
    requestId;
    /** Dev-facing server text — log it, never render it. */
    serverMessage;
    constructor(args) {
        super(`api error ${args.httpStatus}: ${args.code}`);
        this.name = "ApiError";
        this.code = args.code;
        this.httpStatus = args.httpStatus;
        this.requestId = args.requestId;
        this.serverMessage = args.serverMessage;
    }
}
function fallbackCode(httpStatus) {
    switch (httpStatus) {
        case 401:
            return "unauthorized";
        case 403:
            return "forbidden";
        case 404:
            return "not_found";
        case 409:
            return "conflict";
        case 429:
            return "rate_limited";
        default:
            return httpStatus >= 500 ? "unknown" : "bad_request";
    }
}
export function errorFromBody(httpStatus, body, requestId) {
    let code;
    let serverMessage;
    if (body && typeof body === "object") {
        const b = body;
        if (typeof b.error === "string") {
            code = b.error;
            if (typeof b.message === "string")
                serverMessage = b.message;
        }
        else if (b.error && typeof b.error === "object") {
            const e = b.error;
            if (typeof e.code === "string")
                code = e.code;
            if (typeof e.message === "string")
                serverMessage = e.message;
        }
    }
    return new ApiError({
        code: (code ?? fallbackCode(httpStatus)).toLowerCase(),
        httpStatus,
        requestId,
        serverMessage,
    });
}
/** Network-level failure (DNS, offline, CORS, aborted). */
export function networkError(cause) {
    const err = new ApiError({ code: "network", httpStatus: 0 });
    if (cause !== undefined)
        err.cause = cause;
    return err;
}
//# sourceMappingURL=errors.js.map